export default class TopixTrendService {
  getAll() {
    return fetch("https://api.tradersr.com/api/topixtrend")
      .then(res => res.json());
  }
}